/* global conversionTarget, grecaptcha, gtag, pricingRequestSuccessMsg, isGoogleAnalyticsEnabled, isTns -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import { ajax } from '@common/ajax-helpers';
import { errorHandler } from '@common/errors';
import { success } from '@common/alert';
import 'slick-carousel';
import TagManager from '@common/tagmanager';

$(() => {
    const getAdvertiseTestData = (url) => {
        return ajax({
            method: 'GET',
            url: url,
        });
    };
    $('#quickconnect-card-carosuel').slick({
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        slidesToShow: 3,
        centerMode: true,
        arrows: false,
        slidesToScroll: 1,
        autoplay: false,
        responsive:
            [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,

                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    },
                },
            ],
    });

    $('.quickconnect-card-prev').click(function() {
        $('#quickconnect-card-carosuel').slick('slickPrev');
    });

    $('.quickconnect-card-next').click(function() {
        $('#quickconnect-card-carosuel').slick('slickNext');
    });

    function mobileSlide() {
        $('#plan-cards').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            mobileFirst: true,
            arrows: false,
        });
    }

    function handleResize() {
        if (window.innerWidth < 768) {
            if (!$('#plan-cards').hasClass('slick-initialized')) {
                mobileSlide();
            }
        } else {
            if ($('#plan-cards').hasClass('slick-initialized')) {
                $('#plan-cards').slick('unslick');
            }
        }
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    $('#plan-cards-prev').on('click', () => {
        $('#plan-cards').slick('slickPrev');
    });

    $('#plan-cards-next').on('click', () => {
        $('#plan-cards').slick('slickNext');
    });

    $('#advertise-test-data').on('click', function() {
        const $btn = $(this);
        const $form = $('#form-advertise');

        getAdvertiseTestData($btn.data('source'))
            .then((testData) => {
                $form.find(':input[name=company_name]').val(testData.company_name);
                $form.find(':input[name=contact_name]').val(testData.contact_name);
                $form.find(':input[name=email]').val(testData.email);
                $form.find(':input[name=phone]').val(testData.phone);
                $form.find(':input[name=message]').val(testData.message);
            })
            .catch(errorHandler);
    });

    if (pricingRequestSuccessMsg.length > 0) {
        if (isGoogleAnalyticsEnabled && !isTns) {
            gtag('event', 'click', {
                'event_category': 'Pricing Requests',
                'event_label': 'Request Pricing',
            });
        }

        if (conversionTarget && !isTns) {
            gtag('event', 'conversion', {
                send_to: conversionTarget,
            });
        }

        if (isTns) {
            if (document.referrer.match(/linkedin.com/) !== null) {
                TagManager.advertiseRequestSubmittedLinkedin();
            } else {
                TagManager.advertiseRequestSubmitted();
            }
        }

        success('Someone from our team will reach out soon!', 'Thank you!');
    }

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        placement: 'bottom',
        boundary: 'viewport',
    });

    const $form = $('#form-advertise');
    const parsley = $form.parsley();

    window.onGoogleReCaptchaCallback = function() {
        $form[0].submit();
    };

    $form.on('submit', function(event) {
        event.preventDefault();

        parsley.whenValidate()
            .done(() => {
                grecaptcha.execute();
            });
    });
});
